/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_User_Segments_LabelInputs */



/**
* | output |
* | --- |
* | "User Segments" |
*
* @param {Segment_Event_Group_User_Segments_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_user_segments_label = /** @type {((inputs?: Segment_Event_Group_User_Segments_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_User_Segments_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Segments utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzersegmente")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segmenti di utenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сегменты пользователей")
	if (locale === "es") return /** @type {LocalizedString} */ ("Segmentos de usuarios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户细分")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーセグメント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता खंड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Segmentos de usuários")
	return /** @type {LocalizedString} */ ("User Segments")
});